import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthProvider";

const ProtectedRoute = ({ redirectPath = "/login" }) => {
  const { auth } = useAuth();
  if (!auth) {
    console.log("No Auth Protected");
    return <Navigate to={redirectPath} replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
